import { render, staticRenderFns } from "./LandingPageCategoryProduct.vue?vue&type=template&id=4ce3f841&"
import script from "./LandingPageCategoryProduct.vue?vue&type=script&lang=js&"
export * from "./LandingPageCategoryProduct.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCategoryProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports